var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"w-full relative"},[_c('img',{staticClass:"w-full cvr-img-ht",attrs:{"src":require("../../../assets/images/joinus-bg.png"),"alt":"bg"}}),_c('p',{staticClass:"text-black covertext absolute w-full text-center"},[_vm._v("\n      Terms & Conditions for Caregiver Saathi\n    ")])])])
}]

export { render, staticRenderFns }